import { IImpactForm } from 'src/types/impacts.type'

export const initialFormState = (code: string): IImpactForm => ({
  name: '',
  code,
  quantity: '',
  quantity_type: null,
  description: '',
  image: {
    icon: '',
    file: null,
  },
  image_small: null,
  image_medium: null,
  media: [],
  un_sdg: [],
  selectedSteps: [],
  selectedProducts: [],
  selectedScanners: [],
  period: null,
  period_start: null,
  types: [],
})
